import actions from "@/modules/staff/store/actions";
import getters from "@/modules/staff/store/getters";
import mutations from "@/modules/staff/store/mutations";

export default {
    state: {},
    actions: actions,
    getters: getters,
    mutations: mutations
}